export const getPost = {
  id: 1,
  title: "This is the first post",
  content: "<p>Sample post content</p>"
};
